// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"57706879","316":"94198b78","453":"d352da71","830":"cd6bf73f","971":"2c545aec"}[chunkId] + ".chunk.js";
};